/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import { DtpList } from 'dtp-react-components';
import {
  // Button,
  Grid,
  Input,
  Modal,
  Title,
} from '../../components/index';
import {
  doGetFile,
} from '../../utils/requests';

class DadosHistoricoRequerimento extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
  }

  getInitialState = () => ({
    exigencia: null,
    showModal: false,
    montouEstadoMock: false,
  })

  visualizaExigencia = (exigencia) => {
    this.setState({
      exigencia,
      showModal: !this.state.showModal,
    });
  }

  montaHistoricoEstados = () => {
    const listaRelacoes = [];
    // const lista = this.montaEstadoMock(this.props.historicoEstados);
    this.props.historicoEstados.forEach((estado, index) => {
      listaRelacoes.push(this.montaListaEstados(estado, index));
    });
    return listaRelacoes;
  }

  montaListaEstados = (estado) => {
    let titulo = '';
    if (this.props.auth.checkPermission(['requerer-compensacao-rpps'])) {
      titulo = `${estado.estado} - ${estado.dataInicio} ${estado.codigoEstado === '4' ?
        `- Dias no estado : ${estado.quantidadeDiasEmAnalise}` : ''}`;
    } else {
      titulo = `${estado.estado} - ${estado.dataInicio}`;
    }
    return (
      <li>
        <Title title={titulo} type="section" fontWeight="regular-16" />
        {this.montaEstado(estado)}
      </li>
    );
  }

  montaEstadoMock= (estados) => {
    const { montouEstadoMock } = { ...this.state };
    const listaEstados = estados;
    const estadoIndeferido =
    {
      estado: 'Indeferido',
      dataInicio: '27/11/2022',
      motivos: [
        {
          protocolo: '01000002789198471122052019',
          estado: '9',
          dataInicioEstado: '12/12/2022',
          motivo: 1000,
          nome: 'Teste Cucumber Outro I',
          comentario: 'teste1',
        },
        {
          protocolo: '01000002789198471122052019',
          estado: '9',
          dataInicioEstado: '12/12/2022',
          motivo: 1001,
          nome: 'Teste Cucumber Outro V',
          comentario: 'teste2',
          idDocumento: '01000002789198471122052019023011202211163248410',
          tipoDocumento: 'Download documento de justificativa',
        },
        {
          protocolo: '01000002789198471122052019',
          estado: '9',
          dataInicioEstado: '12/12/2022',
          motivo: 1002,
          nome: 'Teste Cucumber Outro II',
          comentario: 'teste3',
          idDocumento: '01000002789198471122052019133011202211140763598',
          tipoDocumento: 'Download documento de justificativa',
        },
      ],
      codigoEstado: '9',
    };
    if (!montouEstadoMock) {
      listaEstados.push(estadoIndeferido);
      this.setState({
        montouEstadoMock: true,
      });
    }
    return listaEstados;
  }

  montaEstado = (estado) => {
    const listaItens = [];
    if (estado.motivo) {
      listaItens.push(this.montaMotivo(estado));
    }
    if (estado.comentarioEstadoRequerimento) {
      listaItens.push(this.montaComentarioEstadoRequerimento(estado));
    }
    if (estado.exigencias) {
      if (estado.exigencias.length > 0) {
        listaItens.push(this.montaListaExigencias(estado.exigencias));
      }
    }
    if (estado.acoesAuditoria) {
      listaItens.push(this.montaListaItensAcaoAuditoria(estado.acoesAuditoria));
    }
    if (estado.alertas) {
      listaItens.push(this.montaListaAlertas(estado.alertas));
    }
    if (estado.motivos) {
      listaItens.push(this.montaListaMotivosIndeferimento(estado.motivos));
    }
    // if (listaItens.length === 0) {
    //   listaItens
    //     .push('Não há detalhes a serem exibidos para este Estado.');
    // }
    return listaItens;
  }

  montaListaExigencias = exigencias => (
    <React.Fragment>
      <br />
      <b>Exigência(s) criada(s):</b>
      <ul>
        {this.montaItensExigencia(exigencias)}
      </ul>
    </React.Fragment>
  );

  montaItensExigencia = (exigencias) => {
    const lista = [];
    exigencias.forEach((exigencia) => {
      lista.push(this.montaExigencia(exigencia));
    });
    return lista;
  }

  montaExigencia = (exigencia) => {
    let dataEncerramento = '';
    let comentario = '';
    let motivoNaoAtendimento = '';
    let comentarioNaoAtendimento = '';
    if (exigencia.dataEncerramento) {
      dataEncerramento = (
        <React.Fragment>
          <b>Encerrada em: </b>
          <span>
            {exigencia.dataEncerramento}
          </span>
          <br />
        </React.Fragment>
      );
    }
    if (exigencia.comentario) {
      comentario = (
        <React.Fragment>
          <b>Comentário: </b>
          <span>
            {exigencia.comentario}
          </span>
          <br />
        </React.Fragment>
      );
    }
    if (exigencia.motivoNaoAtendimento) {
      motivoNaoAtendimento = (
        <React.Fragment>
          <b>Motivo para o não atendimento: </b>
          <span>
            {exigencia.motivoNaoAtendimento}
          </span>
          <br />
        </React.Fragment>
      );
    }
    if (exigencia.comentarioNaoAtendimento) {
      comentarioNaoAtendimento = (
        <React.Fragment>
          <b>Comentário para o não atendimento: </b>
          <span>
            {exigencia.comentarioNaoAtendimento}
          </span>
        </React.Fragment>
      );
    }
    return (
      <li>
        <p>
          <br />
          <b>{exigencia.acao} - {exigencia.situacao}</b>
        </p>
        <ul>
          <li>
            {dataEncerramento}
            {comentario}
            {motivoNaoAtendimento}
            {comentarioNaoAtendimento}
          </li>
        </ul>
      </li>
    );
  }

  montaMotivo = estado => (
    <ul>
      <li>
        <b>Motivo: </b>
        <span>
          {estado.motivo}
        </span>
      </li>
    </ul>
  )

  montaComentarioEstadoRequerimento = estado => (
    <ul>
      <li>
        <b>Comentário do Analista: </b>
        <span>
          {estado.comentarioEstadoRequerimento}
        </span>
      </li>
    </ul>
  )

  montaListaItensAcaoAuditoria = itens => (
    <React.Fragment>
      <br />
      <b>Ação(ões) ocorrida(s) neste estado:</b>
      <ul>
        {this.montaItensAcaoAuditoria(itens)}
      </ul>
    </React.Fragment>
  );

  montaItensAcaoAuditoria = (itens) => {
    const listaAcoes = [];
    itens.forEach((acao) => {
      listaAcoes.push(this.montaAcaoAuditoria(acao));
    });
    return listaAcoes;
  }

  montaAcaoAuditoria = (acao) => {
    const itemAuditoria = [];
    if (acao.data) {
      itemAuditoria.push(acao.data);
    }
    if (acao.nome) {
      itemAuditoria.push(acao.nome);
    }
    if (acao.descricao) {
      itemAuditoria.push(acao.descricao);
    }
    return (
      <li>
        <p>
          <b>{itemAuditoria.join(' - ')}</b>
        </p>
      </li>
    );
  }

  montaAlerta = (acao) => {
    const itemAlerta = [];
    if (acao.data) {
      itemAlerta.push(acao.operacao);
    }
    if (acao.descricao) {
      itemAlerta.push(acao.descricao);
    }
    return (
      <li>
        <p>
          <b>{itemAlerta.join(' : ')}</b>
        </p>
      </li>
    );
  }

  montaMotivoIndeferimento= (motivo) => {
    const itemMotivo = [];
    const itemArquivo = [];
    if (motivo.dataInicio) {
      itemMotivo.push(motivo.descricao);
    }
    if (motivo.comentario) {
      itemMotivo.push(motivo.comentario);
    }
    let nomeDocumentoMotivo = '';
    if (motivo.documento) {
      nomeDocumentoMotivo = motivo.documento.toString();
      if ((motivo.documento).indexOf('/') !== -1) {
        nomeDocumentoMotivo = (motivo.documento.toString()).replace('/', '-');
      }
      itemArquivo.push('Download documento de justificativa');
    }
    return (
      <li>
        <p>
          <b>{itemMotivo.join(' : ')}</b>
          {(itemArquivo && itemArquivo.length > 0) ?
            <p>
              <b>
                <a
                  style={{ padding: '0', margin: '10px' }}
                  href="#"
                  onClick={() => this.downloadDocument(nomeDocumentoMotivo, 'Documento de justificativa')}
                >
                  {itemArquivo}
                </a>
              </b>
            </p>
          : ''}
        </p>
      </li>
    );
  }

  montaMotivoCessacaoManual = () => {
    const itemMotivo = [];
    itemMotivo.push(this.props.labelMotivoCessacao);
    return (
      <li>
        <p>
          <b>{itemMotivo.join(' : ')}</b>
        </p>
      </li>
    );
  }

  downloadDocument = (idDocumento, filename) => {
    doGetFile(idDocumento, filename);
  }

  montaItensAlerta = (itens) => {
    const listaAlertas = [];
    itens.forEach((acao) => {
      listaAlertas.push(this.montaAlerta(acao));
    });
    return listaAlertas;
  }

  montaItensMotivoIndeferimento = (itens) => {
    const listaMotivos = [];
    itens.forEach((motivo) => {
      if (this.props.labelMotivoCessacao !== null) {
        listaMotivos.push(this.montaMotivoCessacaoManual());
      } else {
        listaMotivos.push(this.montaMotivoIndeferimento(motivo));
      }
    });
    return listaMotivos;
  }

  montaListaAlertas = itens => (
    <React.Fragment>
      <br />
      <b>Alerta(s) neste estado:</b>
      <ul>
        {this.montaItensAlerta(itens)}
      </ul>
    </React.Fragment>
  );

  montaListaMotivosIndeferimento= itens => (
    <React.Fragment>
      <br />
      <b>Motivo(s) neste estado:</b>
      <ul>
        {this.montaItensMotivoIndeferimento(itens)}
      </ul>
    </React.Fragment>
  );

  handleModal = () => {
    this.setState({ showModal: !this.state.showModal });
  }

  montaModalContent = () => (
    <React.Fragment>
      <div className="row">
        <Grid cols="4 4 4 4">
          <Input
            disabled
            label="Ação"
            value={this.state.exigencia.acao}
          />
        </Grid>
        <Grid cols="4 4 4 4">
          <Input
            disabled
            label="Data de Encerramento"
            value={this.state.exigencia.dataEncerramento}
          />
        </Grid>
        <Grid cols="4 4 4 4">
          <Input
            disabled
            label="Situação"
            value={this.state.exigencia.situacao}
          />
        </Grid>
      </div>
      <div className="row">
        <Grid cols="6 6 6 6">
          <Input
            componentClass="textarea"
            disabled
            label="Comentário"
            value={this.state.exigencia.comentario}
            textarea
          />
        </Grid>
        { this.state.exigencia.comentarioNaoAtendimento ? (
          <Grid cols="6 6 6 6">
            <Input
              componentClass="textarea"
              disabled
              label="Comentário para não cumprimento"
              value={this.state.exigencia.comentarioNaoAtendimento}
              textarea
            />
          </Grid>
        ) : '' }
      </div>
    </React.Fragment>
  );

  render() {
    let modal;
    if (this.state.showModal) {
      modal = (
        <Modal
          {...this.props}
          conteudomodal={this.montaModalContent()}
          onHide={this.handleModal}
          showTitle
          size="lg"
          title="Detalhes da exigência"
          showModal
        />
      );
    }
    return (
      <React.Fragment>
        <ol>
          {this.montaHistoricoEstados()}
        </ol>
        {/* <DtpAccordionGroup>
          {this.montaHistoricoEstados()}
        </DtpAccordionGroup> */}
        {modal}
      </React.Fragment>
    );
  }
}

DadosHistoricoRequerimento.defaultProps = {
  labelMotivoCessacao: null,
};

DadosHistoricoRequerimento.propTypes = {
  historicoEstados: PropTypes.arrayOf(PropTypes.string).isRequired,
  auth: PropTypes.objectOf(PropTypes.object).isRequired,
  labelMotivoCessacao: PropTypes.string,
};

export default DadosHistoricoRequerimento;



// WEBPACK FOOTER //
// ./src/pages/requerimentos/DadosHistoricoRequerimento.jsx